// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
import "@fontsource/roboto"
import "../stylesheets/application.scss"
import "../stylesheets/data_table.scss"
import "@lmu-med/styles/dist/lmu.css"
import "../stylesheets/global-variables.scss"
import "../stylesheets/scaffolds.scss"
import "@fortawesome/fontawesome-free/css/all"

import jquery from 'jquery'
window.jQuery = jquery
window.$ = jquery

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
Rails.start()
Turbolinks.start()
ActiveStorage.start()

import "./data_tables"
import "./data_safety"
import "./select2"
import "./warn_unsaved"

import bootstrap from 'bootstrap'

const images = require.context("../images", true)
